import React, { useCallback, useEffect } from 'react';

import './RadioButton.scss';

export default function RadioButton({ isOn, setOn, setOffOthers, light, additionalRef }) {
    const onClick = useCallback(() => {
        setOn(true);
        for (let i = 0; i < setOffOthers.length; i++) {
            const f = setOffOthers[i];
            f(false);
        }
    }, [setOn, setOffOthers])

    useEffect(() => {
        if (additionalRef) {
            const elem = additionalRef.current;
            elem.onclick = onClick;
            return () => {
                elem.onclick = undefined;
            }
        }
    }, [additionalRef, onClick]);

    let className = "radio-button";
    if (light)
        className += " light"
    if (isOn)
        className += " on"

    return (
        <div className={className} onClick={onClick}>
            {isOn ? <div className="dot" /> : null}
        </div>
    );
}

/**
    const [b1, setB1] = useState(true);
    const [b2, setB2] = useState(false);
    const [b3, setB3] = useState(false);


    <RadioButton light isOn={b1} setOn={setB1} setOffOthers={[setB2, setB3]} />
    <RadioButton light isOn={b2} setOn={setB2} setOffOthers={[setB1, setB3]} />
    <RadioButton light isOn={b3} setOn={setB3} setOffOthers={[setB1, setB2]} />
 */